import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { auth } from './firebase'; // Import auth for sign-out example
import './HomePage.css';

import Tcurl1 from './assets/title_curl_1.svg';
import Tcurl2 from './assets/title_curl_2.svg';
import FIcon1 from './assets/tiktok.png';
import FIcon2 from './assets/google-play-store.png';
import FIcon3 from './assets/facebook1.png';
import FIcon4 from './assets/instagram1.png';
import PrimaryButton from './PrimaryButton';
import SecondaryButton from './SecondaryButton';
import TertiaryButton from './TertiaryButton';
import SubscriptionForm from './SubscriptionForm';
import Scurl1 from './assets/socials_curl1.svg';
import Hcurl1 from './assets/howto_curl1.svg';
import Hcurl2 from './assets/howto_curl2.svg';
import Hcurl3 from './assets/howto_curl3.svg';
import Scurl2 from './assets/socials_curl2.svg';
import { FaChevronDown } from 'react-icons/fa';
import { Helmet } from 'react-helmet-async';

import { db } from './firebase'; // Import your Firestore instance
import { collection, addDoc } from 'firebase/firestore';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom'; // Import useNavigate hook
import ReactGA from 'react-ga4';
import ReactPixel from 'react-facebook-pixel';


const HomePage = ({ onLoginClick }) => {


  const location = useLocation();
  const langPrefix = location.pathname.split('/')[1] || 'en';
  const navigate = useNavigate(); // Hook to programmatically navigate


  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleLanguageChange = (lang) => {
    toggleDropdown()
    navigate(`/${lang}`)
  };

  const handleHomeClick = (e) => {
    e.preventDefault();  // Prevent the default link behavior
    window.location.reload();  // Refresh the page
  };

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);


  const [email, setEmail] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const docRef = await addDoc(collection(db, 'emailFeedback'), {
        email: email,
        timestamp: new Date()
      });
      console.log('Document written with ID: ', docRef.id);
      setEmail('');
    } catch (e) {
      console.error('Error adding document: ', e);
    }
  };

  useEffect(() => {
    let hasScrolledPastFirst = false;
    let hasScrolledPastSecond = false;

    const handleScroll = () => {
      const scrollPosition = window.scrollY // Current scroll position + viewport height
      const targetHeight = window.innerHeight * 0.9; // Total document height
      const targetHeight2 = window.innerHeight * 1.8; // Total document height

      if (!hasScrolledPastFirst && scrollPosition > targetHeight) {
        hasScrolledPastFirst = true; // Set flag
        ReactGA.event({
          category: 'Scroll',
          action: 'Scroll_1',
          label: 'User scrolled past first section',
        });
        ReactPixel.trackCustom('Scroll_1');
      };

      if (!hasScrolledPastSecond && scrollPosition > targetHeight2) {
        hasScrolledPastSecond = true; // Set flag
        ReactGA.event({
          category: 'Scroll',
          action: 'Scroll_2',
          label: 'User scrolled past second section',
        });
        ReactPixel.trackCustom('Scroll_2');
      }
    }


    window.addEventListener('scroll', handleScroll);

    // Cleanup on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);



  return (
    <div className="App">
      <Helmet>
        <title>Jointly App - Meet New People By Doing Activities In Belgium</title>
        <meta name="description" content="Join Jointly to meet people and create friendships by doing activities you create like game nights, bowling, sports... Active in Gent, Leuven, Antwerp, Brussels" />
        <link rel="canonical" href="https://www.joinjointly.com/" />
        <meta name="author" content="Jointly App" />
        <meta name="keywords" content="Meeting new people, Making friends near me, Activities, Activity-based connections, Growing your social circle" />
      </Helmet>
      <section id="title-page" className="title-page">
        <div className="title-page-container">
          <div className="title-curl1-container">
            <img src={Tcurl1} alt="Title Curl1" className="title-curl1" />
          </div>
          <div className="title-curl2-container">
            <img src={Tcurl2} alt="Title Curl2" className="title-curl2" />
          </div>
          <div className="title-secundary-container" onClick={handleHomeClick}>
            <img src='/assets/secondary_blue1.svg' alt="Jointly, the app to make new friends" className="title-secundary" />
          </div>
          <div className="title-nav-top-container">
            <div className="title-nav-about-cont">
              <a href="#" onClick={handleHomeClick} className="nav-link">Home</a>
            </div>
            <div className="title-nav-gallery-cont">
              <a href="#" onClick={() => scrollToSection('howto-page')} className="nav-link">About</a>
            </div>
            <div className="title-nav-vision-cont">
              <a href="#" onClick={() => scrollToSection('socials-page')} className="nav-link">Gallery</a>
            </div>
            <div className="title-nav-contact-cont">
              <Link to={`/${langPrefix}/blog`} className="nav-link">Blog</Link>
            </div>
            <div className="language-dropdown-cont">
              {/* Language Selector (Dropdown Trigger) */}
              <div className="language-selector" onClick={toggleDropdown}>
                <img src='/assets/globe.webp' alt="language selection" className="flag-icon" />
                <span className="langtext">EN</span>
                <FaChevronDown className="arrow-icon" />
              </div>

              {/* Dropdown Menu */}
              {isDropdownOpen && (
                <div className="dropdown-menu">
                  <div className="dropdown-item" onClick={() => handleLanguageChange('en')}>
                    <span className='title-lang'>EN</span>
                  </div>
                  <div className="dropdown-item" onClick={() => handleLanguageChange('nl')}>
                    <span className='title-lang'>NL</span>
                  </div>
                </div>
              )}
            </div>
          </div>





          <div className="title-nav-buttons-container">
            <SecondaryButton text="Login" width="8.3vw" height="5.10vh" borderRadius={"8px"} onLoginClick={onLoginClick} />
            <PrimaryButton text="Sign up" width="8.5vw" height="5.10vh" borderRadius={"8px"} onLoginClick={onLoginClick} />
          </div>
          <div className="title-cards-container">
            <img src='/assets/title_cards_7.webp' alt="Creating friendship or meeting people during activities like game night or paintball" className="title-cards" />
          </div>
          <div className="blurred-circle"></div>
          <div className="title-jointly-cont">
            <h1 className="title-jointly">Jointly</h1>
          </div>
          <div className="title-slogan-cont">
            <span className="title-slogan">Experience it together</span>
          </div>
          <div className="title-intro-cont">
            <h2 className="title-intro">Meet the people you want, by</h2>
            <h2 className="title-intro">doing the activities you love</h2>
            {/* <h2 className="title-intro">all on one platform</h2> */}
          </div>
          <div className="title-getstarted-cont">
            <PrimaryButton text="Join Jointly" width="100%" height="100%" borderRadius={"10px"} onLoginClick={onLoginClick} fontSize={'calc((1.2vw / 2) + (1.2rem / 2))'} />
          </div>
        </div>
      </section>

      <section id="howto-page" className="howto-page">
        <div className="howto-page-container">
          <div className="howto-header-cont">
            <h2 className="howto-header">What is Jointly?</h2>
          </div>
          <div className="howto-desc-cont">
            <span className="howto-desc">Whether you are new in town, bored, or just looking to expand your social circle, Jointly is here for you. Get</span>
            <span className="howto-desc">to know the people you choose by doing activities you like. <span className="highlight">Find friends nearby, network with new business</span></span>
            <span className="howto-desc"><span className="highlight">contacts, or gather a group</span> for a one-time adventure. It's simple:</span>
          </div>
          <div className="howto-curl1-container">
            <img src={Hcurl1} alt="Howto Curl1" className="howto-curl1" />
          </div>
          <div className="howto-curl2-container">
            <img src={Hcurl2} alt="Howto Curl2" className="howto-curl2" />
          </div>
          <div className="howto-curl3-container">
            <img src={Hcurl3} alt="Howto Curl3" className="howto-curl3" />
          </div>
          <div className="howto-getstarted-cont">
            <PrimaryButton text="Get Started" width="100%" height="100%" borderRadius={"10px"} onLoginClick={onLoginClick} fontSize={'calc((1.2vw / 2) + (1.2rem / 2))'} />
          </div>
          <div className="howto-card1-cont">
            <div className="howto-card1t-cont">
              <img src='/assets/howto_cardimg1.webp' alt="Create small-scale activities on this friendship app and find people to do them with" className="howto-cardimg" loading="lazy" />
            </div>
            <div className="howto-card1b-cont">
              <div className="howto-cardtext-cont">
                <p className="howto-cardtext">1. <span className="highlight">Create the activity</span> you want, set the details and decide who can apply</p>
              </div>
            </div>
          </div>
          <div className="howto-card2-cont">
            <div className="howto-card2t-cont"><img src='/assets/howto_cardimg2.webp' alt="Meet like-minded people by deciding who can join" className="howto-cardimg" loading="lazy" /></div>
            <div className="howto-card2b-cont">
              <div className="howto-cardtext-cont">
                <p className="howto-cardtext">2. <span className="highlight">Review and accept applications </span>from potential joiners</p>
              </div>
            </div>
          </div>
          <div className="howto-card3-cont">
            <div className="howto-card3t-cont"><img src='/assets/howto_cardimg3.webp' alt="Connect with new people via chat and after in real-life for your activity" className="howto-cardimg" loading="lazy" /></div>
            <div className="howto-card3b-cont">
              <div className="howto-cardtext-cont">
                <p className="howto-cardtext">3. <span className="highlight">Connect with them</span> in the activity hub and schedule your activity</p>
              </div>
            </div>
          </div>
          <div className="howto-card4-cont">
            <div className="howto-card4t-cont"><img src='/assets/howto_cardimg4.webp' alt="Enjoy meeting new people while an activity you like" className="howto-cardimg" loading="lazy" /></div>
            <div className="howto-card4b-cont">
              <div className="howto-cardtext-cont">
                <p className="howto-cardtext">4. Enjoy the experience <span className="highlight">together!</span></p>
              </div>
            </div>
          </div>
          <div className="blurred-ellips"></div>
        </div>
      </section>

      <section id="socials-page" className="socials-page">
        <div className="socials-page-container">
          <div className="socials-header-cont">
            <h1 className="socials-header">Ready to meet new people,<br></br>join activities, and share<br></br> experiences together?</h1>
          </div>

          <div className="socials-button-cont">
            <TertiaryButton text="Join Jointly" width="100%" height="100%" borderRadius={"10px"} onLoginClick={onLoginClick} />
          </div>

          <div className="socials-seeyou-cont">
            <p className="socials-seeyou-text">See you inside!</p>
          </div>

          <div className='socials-images-cont'>
            <div className="socials-img1-container">
              <img src='/assets/socials_img1.webp' alt="Meet people during workshops" className="socials-img" loading="lazy" />
            </div>
            <div className="socials-img1-container">
              <img src='/assets/socials_img2.webp' alt="Do bowling with new friends via the app" className="socials-img" loading="lazy" />
            </div>
            <div className="socials-img1-container">
              <img src='/assets/socials_img5.webp' alt="Find sport group in Belgian cities with the Jointly App" className="socials-img" loading="lazy" />
            </div>
            <div className="socials-img1-container">
              <img src='/assets/socials_img3.webp' alt="Escape room with new connections" className="socials-img" loading="lazy" />
            </div>
            <div className="socials-img1-container">
              <img src='/assets/socials_img4.webp' alt="Find people to go for a drink with in Antwerp, Gent, Brussels or Leuven" className="socials-img" loading="lazy" />
            </div>
            <div className="socials-img1-container">
              <img src='/assets/socials_img6.webp' alt="Have fun while meeting new people doing your hobby" className="socials-img" loading="lazy" />
            </div>
          </div>

          {/* <div className="socials-img1-container">
            <img src='/assets/socials_img1.webp' alt="Meet people during workshops" className="socials-img" loading="lazy" />
          </div>
          <div className="socials-img2-container">
            <img src='/assets/socials_img2.webp' alt="Do bowling with new friends via the app" className="socials-img" loading="lazy" />
          </div>
          <div className="socials-img3-container">
            <img src='/assets/socials_img5.webp' alt="Find sport group in Belgian cities with the Jointly App" className="socials-img" loading="lazy" />
          </div>
          <div className="socials-img4-container">
            <img src='/assets/socials_img3.webp' alt="Escape room with new connections" className="socials-img" loading="lazy" />
          </div>
          <div className="socials-img5-container">
            <img src='/assets/socials_img4.webp' alt="Find people to go for a drink with in Antwerp, Gent, Brussels or Leuven" className="socials-img" loading="lazy" />
          </div>
          <div className="socials-img6-container">
            <img src='/assets/socials_img6.webp' alt="Have fun while meeting new people doing your hobby" className="socials-img" loading="lazy" />
          </div> */}
        </div>
      </section>


      <section className="footer-page">
        <div className="footer-page-container">
          <div className="footer-secundary-container" onClick={handleHomeClick}>
            <img src='/assets/secondary_blue2.svg' alt="title Secundary" className="footer-secundary" />
          </div>
          <div className="footer-desc-cont">
            <p className="footer-desc">Jointly makes building connections natural and easy. Our goal is to help you have a
              great time doing activities you love while meeting like-minded people.</p>
          </div>
          <div className="footer-copy-cont">
            <p className="footer-copy">@2025 Jointly - Breco Techlab BV. All rights reserved.</p>
          </div>
          <div className="footer-links-cont">
            <Link to={`/${langPrefix}`} className="footer-link">Home</Link>
            <Link to={`/${langPrefix}#howto-page`} className="footer-link">About</Link>
            <Link to={`/${langPrefix}#socials-page`} className="footer-link">Gallery</Link>
            <Link to={`/${langPrefix}/blog`} className="footer-link">Blog</Link>
          </div>
          <div className="footer-icon1-container">
            <div className="footer-icon2-container">
              <a href="https://www.tiktok.com/@jointlybe" className="footer-copy">
                <img src={FIcon1} alt="title Secundary" className="footer-icon" />
              </a>
              <a href="https://www.instagram.com/joinjointly/" className="footer-copy">
                <img src={FIcon4} alt="title Secundary" className="footer-icon" />
              </a>
            </div>
            <div className="footer-icon2-container">
              <a href="https://www.facebook.com/profile.php?id=61567021295749" className="footer-copy">
                <img src={FIcon3} alt="title Secundary" className="footer-icon" />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.joinjointly.jointlyapp" className="footer-copy">
                <img src={FIcon2} alt="title Secundary" className="footer-icon2" />
              </a>
            </div>
          </div>
          <div className="footer-terms-cont">
            <a href="https://www.joinjointly.com//terms.html" className="footer-copy">Terms and conditions</a>
            <div className="footer-spacer"></div>


            <a href="https://www.joinjointly.com//privacypolicy.html" className="footer-copy">Privacy policy</a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default HomePage;
